import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DashboardHeader from "../../Pages/DashboardHeader/DboardHeader";
import Sidebarcomp from "../../Pages/Sidebar/Sidebar";
import "./admin.css";
import { Outlet } from "react-router-dom";
import { CommunityOwner } from "../../Utils/Constant";

function Admin() {
  const navigate = useNavigate();

  useEffect(() => {
    // Retrieve the access token and user role from localStorage
    const accessToken = localStorage.getItem("accessToken");
    const userType = localStorage.getItem("user_type");

    // Check if the user is authenticated and is a super-admin


    if (!accessToken || !userType || userType !== CommunityOwner) {
      // If not authenticated or not a super-admin, redirect to login page
      navigate("/"); 
    }
// else{
//   navigate("/admin/dashboard"); 
// }

  }, [navigate]);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [refetch, setRefetch] = useState(false);

  const toggleSidebar = () => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <div className="layout d-flex position-relative">
      <Sidebarcomp isCollapsed={isCollapsed} refetch={refetch} onToggle={toggleSidebar} />
      <div
        className={`main-components d-flex flex-column ${
          isCollapsed ? "full-width" : ""
        }`}
      >
        <DashboardHeader isCollapsed={isCollapsed} />
       
        <Outlet context={{ isCollapsed,refetch, setRefetch }} />
      </div>
    </div>
  );
}

export default Admin;
